import { Pipe, PipeTransform } from '@angular/core';
import { PaymentTermKind } from '@/common/enums/PaymentTermKind';
import { PaymentTermStatus, paymentTermStatusByKindMappings } from '@/common/enums/paymentStatus';

@Pipe({
	name: 'paymentTermStatusLabel',
	standalone: true,
})
export class PaymentTermStatusLabelPipe implements PipeTransform {
	transform(status: PaymentTermStatus | string, kind?: PaymentTermKind): string {
		if (!status) {
			return '';
		}

		const paymentTermKind = kind ?? PaymentTermKind.PAYMENT;

		return paymentTermStatusByKindMappings[paymentTermKind]?.[status as PaymentTermStatus] ?? '';
	}
}
